import { render, staticRenderFns } from "./ReturnPolicy.vue?vue&type=template&id=6de3b9ca"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports